// extracted by mini-css-extract-plugin
export default {"dt":"piHaz_iW395YBucm8bTA","dd":"DUM0WPzZyawUFi325m8Q","placeHolderShimmer":"LNJyFb4b6X3siQ3BDuZD"};